export function formatArtistLink(id, cleanTitle) {
  return `/catalog/artist/${id}/${cleanTitle}`
}

export default { formatArtistLink }
